module.exports = __webpack_public_path__ + "img/PaySuccessCN.fae87b22.png";